<template>
  <div style="width: 100%;">
    <!-- 列表页面 -->
    <div v-if="isShow" class="settlement-list" style="overflow: scroll;height:100%;">
      <div class="list-header">
          <span></span>
          <CustomTool style="width:120px;" :column_mapper="column_mapper" :show-time-area="false" :show-time="false" :show-refresh="false" :show-filter="true" :show-export="false" :filterArchiveData="filterArchiveData" @filters="filterContentChange" @export="exportExcel"/>
      </div>
      <div style="width: calc(100% - 0px)">
        <!-- 表单主体内容 -->
        <div style="height: 100%;width:100%;box-sizing: border-box;padding:0px 0px;overflow: scroll;background:white;">
          <custom-table
              ref="mytable"
              table-id="client-settlement-table"
              :project-list-dl="tableData.projectList"
              :show-coloums-dl="tableData.showColoums"
              :column_mapper="tableData.column_mapper"
              @current-change="currentChange"
              @row-click="rowClick"
              :sort-column-name-dl="tableData.sortColumnName"
              :sort-column-order-dl="tableData.sortColumnOrder"

              :totalnums-dl="tableData.totalnums"
              :pagesize-dl="tableData.pagesize"
              :page-number-dl="tableData.pageNumber"

              :fixed-columns="tableData.fixedList"
              :fixed-right-columns="tableData.fixedRightList"

              :disableDrag="true"
              :sortable="false"
              :sortableColumns="tableData.sortableColumns"

              :pagination="tableData.pagination"

              :is-loading-dl="tableData.detailLoading"
              :use-virtual="false"
              :row-hegit="0"

              :tableColumnCustomConfig="tableData.tableColumnCustomConfig"
              :padding="'0px'"
              :custom-column-width="tableData.customColumnWidth"
          />
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import customTable from "@/component/CustomTable";
import CustomTool from "@/component/Performance/topTool/CustomTool";
import { getClientSettlementList, exportClientSettlementList } from "@/api/api.js";

export default {
  name: "ClueList",
  components:{
    customTable,
    CustomTool,
    getClientSettlementList
  },
  props: ["clientName"],
  data(){
    return {
      isShow:true, //是否展示列表，true为展示客户列表，false会展示详情页面
      // 表格所需数据
      tableData:{
        //表格列表相关
        detailLoading: false,
        projectList: [],//表格列表所有数据
        showProjectList:[],//显示的数据
        column_mapper: {},//表头所有列的枚举
        showColoums: [],//当前显示的表头列
        sortColumnName: "",//需要排序的列名
        sortColumnOrder: "",//排序的命令
        totalnums: 10,//所有的数据条数
        pageNumber: 1,//当前页
        fixedList: [],
        pagesize: 10,//一页数据的行数（公用）
        pagination:true,
        customColumnWidth: {
            settlement_name: 256,
            advance_name: 264,
        }
      },
      filterRequestData:{},
      // 过滤器属性
      filterContent:{
        queryCond: [],
        sortCond: {
          columnName: "",
          value: ""
        },
      },
      filterArchiveData:{
        queryCond: []
      },
      // 控制新增用户按钮
      showAddClient:false,

      column_mapper: {
        "invoice_id": "结算编号:varchar",
        "settlement_name": "结算名称:varchar",
        "actual_amount": "结算总金额:decimal",
        "advance_name": "预付款名称:varchar",
        "advance_amount": "预付款金额:decimal",
        "stat_time": "开票时间:time"
      }
    }
  },
  mounted() {
    this.refresh()
  },
  methods:{
    // 获取分类详情
      getSelection(tab){
        this.tab = tab
        const content = this.filterContent
        const filter = {
            "columnName": "settlement_client",
            "filter": "eq",
            "columnValue": this.clientName
          }
        if (content.hasOwnProperty('queryCond')){
          var tmp = 0
          for (var i in content['queryCond']) {
            if (content['queryCond'][i]['columnName'] == 'settlement_client') {
              content['queryCond'][i]['filter'] = "eq"
              content['queryCond'][i]["columnValue"] = this.clientName
              tmp = 1
            }
          }
          if (tmp == 0) {
            content['queryCond'].push(filter)
          }
        }else{
          content['queryCond'] = [filter]
        }
        Object.assign(this.filterContent,content)
        this.refresh(true)
      },

      filterContentChange(content){
        Object.assign(this.filterContent,content)
        this.refresh(true)
      },
      /**
       * 表格某行点击
       * @param e 点击item数据
       * 点击之后列表页面隐藏，详情页面展示
       */

      
      rowClick(e) {
        window.open("https://www.jiandaoyun.com/dashboard/app/5e5322c89daa2f000602931c/form/5ef19943335f8500068ba5e9/data/" + e.data_id + "/qr_link", "_blank")
      },
      

    currentChange(e) {
        console.log('currentChange',e)
        this.tableData.pageNumber = e;
        this.refresh(false)
      },

      async getData(resetPage=false){
        var tmp = 0
        if(resetPage){
          this.tableData.pageNumber = 1
        }
        const filter = {
            "columnName": "settlement_client",
            "filter": "eq",
            "columnValue": this.clientName
          }
        if (this.filterContent.hasOwnProperty('queryCond')){
          var tmp = 0
          for (var i in this.filterContent['queryCond']) {
            if (this.filterContent['queryCond'][i]['columnName'] == 'settlement_client') {
              this.filterContent['queryCond'][i]['filter'] = "eq"
              this.filterContent['queryCond'][i]["columnValue"] = this.clientName
              tmp = 1
            }
          }
          if (tmp == 0) {
            this.filterContent['queryCond'].push(filter)
          }
        }else{
          this.filterContent['queryCond'] = [filter]
        }
        this.filterRequestData = {
          division:this.currentSelectLeftItemKey,
          pagiInfo: {
            currentPage: this.tableData.pageNumber,
            pagesize: this.tableData.pagesize
          },
          ...this.filterContent
        }
        let postData = this.filterRequestData
        console.log('postData', postData)
        let res = await getClientSettlementList(postData)
        let resData = res
        // console.log("resData", resData)
        const {respData: {cols_mapper, data , columns_list, totalnums}} = resData
        // console.log('返回结果', resData,cols_mapper,data,columns_list)
        this.tableData.column_mapper = cols_mapper
        this.tableData.projectList = data
        this.tableData.totalnums =  totalnums
        this.tableData.showColoums = columns_list
        // console.log('this.tableData.showColoums',this.tableData.showColoums )
        this.$nextTick(() => {
          this.tableData.detailLoading = false
        })

      },

      async refresh(resetPage=false){
        this.tableData.detailLoading = true
        await this.getData(resetPage)
      },

      async exportExcel() {
        let param = this.filterRequestData
        let loadingInstance = this.$loading.service({fullscreen: true, text: '请等待导出'});
        try {
          let {data} = await exportClientSettlementList(param)
          loadingInstance.close();
          const blob = new Blob([data])
          var date = new Date()
          let Y = date.getFullYear().toString()
          let M = (date.getMonth() + 1).toString().padStart(2, "0")
          let D = date.getDate().toString().padStart(2, "0")
          let H = date.getHours().toString().padStart(2, "0")
          let m = date.getMinutes().toString().padStart(2, "0")
          let s = date.getSeconds().toString().padStart(2, "0")
          let fileName = '客户结算-' + Y + M + D + H + m + s + ".xlsx"

          const link = document.createElement('a')
          link.download = fileName
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(link.href)
          document.body.removeChild(link)
        } catch(err) {
            loadingInstance.close();
            var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
            if (issafariBrowser) {
            this.$message.warning("暂不支持在Safari浏览器中导出，请使用其他浏览器")
            } else {
            this.$message.warning(`导出失败,请尝试使用其他浏览器,错误信息(${err})`)
            }
        }
      }
  }
}
</script>

<style scoped>
  .list-header{
    width:calc(100% - 0px);
    display: flex;
    justify-content: space-between;
  }
</style>